import { JsonFragment } from "../abis.model";

export const DAOExpanderRegistryABI: JsonFragment[] = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_autIDAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "_daoTypes",
        type: "address",
      },
      {
        internalType: "address",
        name: "_daoExpanderFactory",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newDAOExpander",
        type: "address",
      },
    ],
    name: "DAOExpanderDeployed",
    type: "event",
  },
  {
    inputs: [],
    name: "autIDAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "daoExpanders",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "daoTypes",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "daoType",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "daoAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "market",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "metadata",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "commitment",
        type: "uint256",
      },
    ],
    name: "deployDAOExpander",
    outputs: [
      {
        internalType: "address",
        name: "_daoExpanderAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getDAOExpanders",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "deployer",
        type: "address",
      },
    ],
    name: "getDAOExpandersByDeployer",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];
